import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class RedirectorGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router,
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.auth.isAdmin) {
      return this.router.createUrlTree(['/admin']);
    }
    if (this.auth.isStudent) {
      return this.router.createUrlTree(['/alu']);
    }
    if (this.auth.isTeacher) {
      return this.router.createUrlTree(['/teacher']);
    }

    return true;
  }

}
